import React from 'react';
import PageMenu from '../../PageMenu';

function MenuResources(props) {
  return (
    <PageMenu
      {...props}
      title="Homebuyer Resources Menu"
      items={[
        {
          name: 'our-process',
          title: 'Our Process',
        },
        {
          name: 'design-center',
          title: 'Design Center',
        },
        {
          name: 'energy-efficiency',
          title: 'Energy Efficiency',
        },
        {
          name: 'financing-info',
          title: 'Financing Info',
        },
        {
          name: 'warranty-info',
          title: 'Warranty Info',
        },
        {
          name: 'military-homebuyers',
          title: 'Military Homebuyers',
        },
        {
          name: 'frequently-asked-questions',
          title: 'Frequently Asked Questions',
        },
      ]}
    />
  );
}

export default MenuResources;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/MenuResources.section.js